<template>
  <li>
    <v-dialog
      v-model="dialog"
      persistent
      retain-focus
      max-width="450"
      content-class="rtls-dialog"
      @keydown.esc="close"
      @click:outside="close"
    >
      <template #activator="{ props: dialogActivatorProps }">
        <v-tooltip location="bottom">
          <template #activator="{ props: tooltipActivatorProps }">
            <v-btn
              v-bind="{ ...dialogActivatorProps, ...tooltipActivatorProps }"
              class="delete-button"
              :disabled="!canDeleteScenario"
              size="small"
              variant="text"
              icon="$trash"
            />
          </template>
          <span>{{ $t('actions.delete') }}</span>
        </v-tooltip>
      </template>

      <BaseDialogCard ref="dialog" :title="tkey('title')" :border="true" @close="close">
        <v-card-text class="text-h6">
          <p class="pb-2">{{ tkey('question', { name: scenario.name }) }}</p>
          <strong>{{ tkey('warning') }}</strong>
        </v-card-text>

        <template #footer>
          <v-card-actions>
            <v-btn primary @click="close">
              {{ $t('actions.cancel') }}
            </v-btn>
            <v-btn secondary variant="flat" class="outlined-btn" @click="_deleteScenario">
              {{ tkey('action') }}
            </v-btn>
          </v-card-actions>
        </template>
      </BaseDialogCard>
    </v-dialog>
  </li>
</template>

<script>
import { mapActions } from 'pinia';
import { usePermission } from '@/composables/use-permission';
import { useInternationalization } from '@/composables/use-internationalization';
import { useScenariosStore } from '@/stores/scenarios';

export default {
  props: {
    scenario: {
      required: true,
      type: Object,
    },
  },
  setup() {
    const { canDeleteScenario } = usePermission();
    const { tkey } = useInternationalization('scenarios.options.delete');
    return {
      canDeleteScenario,
      tkey,
    };
  },
  data() {
    return { dialog: false };
  },
  methods: {
    ...mapActions(useScenariosStore, ['deleteScenario']),
    async _deleteScenario() {
      this.dialog = false;
      await this.deleteScenario(this.scenario);
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';
.title {
  position: relative;
}

.delete-button {
  .v-icon {
    color: $assortment-primary-colour;
  }
}

.close-button {
  position: absolute;
  right: 10px;
  top: 10px;
}
</style>
